import React from 'react'
import ListStudies from './ListStudies'
import '../style/studies.css'

const Studies = () => {

    return (
        <section id="Estudios"className="mt-3 container-fluid"><br></br>
            <h4 className="studies-tittle">Información Académica</h4>
            <ListStudies />
        </section>
    )

}
export default Studies



